export interface DocumentThemeInvoiceHeaderOptions {

    /* Show Job Number - displays the Job Number from the parent job */
    showJobNumber: boolean;

    /* Show Customer WO - displays the Customer WO from the parent job */
    // showCustomerWO: boolean;

    /* Show Site - displays the site from the parent Job */
    showSite: boolean;

    /* Show Reference - displays the reference */
    showReference: boolean;

    /* Show Terms & Conditions - displays the terms & conditions section and the relevant text */
    showTerms: boolean;

    /* Show Notes - displays the notes  */
    showNotes: boolean;

    // /* Show Owner Details - displays the owner, contact number and email address of the parent contact(e.g.opportunity owner) */
    // showOwnerDetails: boolean;

    /* Show Payments sections */
    showPayments: boolean;

    /* Allows overwriting the name quote useful for creating Estimates etc */
    entityName: string;

}


export interface DocumentThemeInvoiceItemOptions {

    /* 
    Show Quantity - if false, no quantity will be displayed
     */
    showQuantity: boolean;

    /* 
    Show Unit Price - if false, no unit price will be displayed 
    */
    showUnitPrice: boolean;

    /* 
    Show Tax - if false, no adjustments will be displayed.the adjustment will either be the percentage or dollar value
    */
    showTax: boolean;


    /*
    Show Total - if false, no line total will be displayed.If true, display the tax amount of the line and the total ex tax
    */
    showTotals: boolean;

    /* Show Zero Price Items*/
    showZeroPrice: boolean;

    showLocation: boolean,
    showNotes: boolean,
    showStatus: boolean

}

export interface DocumentThemeInvoiceAppendixOptions {
    pageBreakBefore: boolean;
    showBillableItems: boolean;
    showActivities: boolean;
    showAttachments: boolean;
    showImagePreview: boolean;
}

export interface DocumentThemeInvoiceOptions {
    header: DocumentThemeInvoiceHeaderOptions;
    items: DocumentThemeInvoiceItemOptions;
    appendix: DocumentThemeInvoiceAppendixOptions;
}

export const defaultInvoiceOptions = {
    header: {
        entityName: 'Tax Invoice',
        showJobNumber: true,
        showReference: true,
        showTerms: true,
        showSite: true,
        showNotes: true,
        showPayments: true,
        // showOwnerDetails: true
    },
    items: {
        showQuantity: true,
        showUnitPrice: true,
        showTax: true,
        showTotals: true,
        showZeroPrice: true
    },
    appendix: {
        pageBreakBefore: true,
        showBillableItems: false,
        showActivities: false,
        showAttachments: false,
        showImagePreview: false
    }
} as DocumentThemeInvoiceOptions;

export const defaultBillOptions = {
    ...defaultInvoiceOptions,
    header: {
        ...defaultInvoiceOptions.header,
        entityName: 'Recipient Created Tax Invoice',
    }
} as DocumentThemeInvoiceOptions;